export default __webpack_public_path__ + "static/media/icon-arrow-left-dark.b4bd4f43.svg";